/**
 * Relatorios customizados (HTML) disponiveis por cliente.
 *
 * A chave e o customerId (salvo no localStorage no login) e o valor e a lista de
 * relatorios que o cliente pode visualizar no Dashboard Customizado. Para liberar
 * um novo relatorio para um cliente basta adicionar um item na lista dele.
 *
 * `nome` e o identificador usado no endpoint v1/DashboardCustomizado/report/{nome}
 * e no parametro da rota /dashboardCustomizado/:nome.
 * `titulo` e o texto exibido no seletor de relatorios da view.
 */
export const relatoriosCustomizadosPorCliente = {
	'b48deec6-b90c-4b59-840d-7b6006f7e3cb': [{ nome: 'nanorads', titulo: "Projeto NANORAD'S" }],
	'46d5a92c-ea8b-4b9d-b925-1e0e5f67bbd8': [{ nome: 'bracell', titulo: 'Bracell' }],
	'0265e5a7-a880-45f4-bb65-f8c5908317dd': [
		{ nome: 'maxima_2', titulo: 'Análise de Sendores IoTs 2026' },
		{ nome: 'maxima', titulo: 'Análise de Sendores IoTs' },
		
	],
	'b45b681d-c584-4e58-91f2-e281cc393873': [{ nome: 'cmpc', titulo: 'CMPC' }],
	'8f6192e6-4263-42b2-9132-fbb0f633a538': [{ nome: 'pontual', titulo: 'Pontual' }],
	'd8ee6d1f-b58f-4aaa-8fe3-f5295f2c9010': [{ nome: 'taboao', titulo: 'Taboão' }],
	'92c9d66a-2a80-4a06-8234-7d94b35b577c': [{ nome: 'aljibes', titulo: 'Aljibes' }],
}

/**
 * Retorna os relatorios customizados de um cliente.
 * Aceita tanto um objeto unico quanto uma lista no mapeamento.
 * @param {string} customerId Id do cliente
 * @returns {Array<{ nome: string, titulo: string }>} Lista de relatorios (vazia se o cliente nao possui)
 */
export const buscarRelatoriosCustomizadosDoCliente = (customerId) => {
	if (!customerId) return []

	const idNormalizado = String(customerId).toLowerCase()
	const mapeamento = Object.entries(relatoriosCustomizadosPorCliente).find(([id]) =>
		idNormalizado.includes(id.toLowerCase()),
	)

	if (!mapeamento) return []

	const relatorios = Array.isArray(mapeamento[1]) ? mapeamento[1] : [mapeamento[1]]
	return relatorios.filter((relatorio) => relatorio && relatorio.nome)
}

/**
 * Retorna os relatorios customizados do cliente que esta logado.
 * @returns {Array<{ nome: string, titulo: string }>}
 */
export const buscarRelatoriosCustomizadosDoClienteLogado = () =>
	buscarRelatoriosCustomizadosDoCliente(localStorage.getItem('customerId'))
